<template lang="pug">
.circles
  .circle(
    v-for="circle in circleNumber"
    :style="{background: getColor(), height: getSize(), width: getSize(true), top: getPostion().x, left: getPostion().y, transform: getTranslate()}")
</template>

<script>
let keepSize = "";
let translateX = 0;
let translateY = 0;
export default {
  props: {
    circleNumber: {
      type: Number,
      default: 6
    }
  },
  methods: {
    getSize(lastSize) {
      if (lastSize) {
        return keepSize;
      }
      let size = Math.random() * 200 + 10;
      keepSize = size + "px";
      return size + "px";
    },
    getColor() {
      const colors = ["#d3efee", "#fde8d3", "#eef2f4"];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    getPostion() {
      let x = Math.random() * 140 - 20;
      let y = Math.random() * 140 - 20;
      translateX = -x;
      translateY = -y;

      return { x: x + "%", y: y + "%" };
    },
    getTranslate() {
      return `translate(${translateX}%, ${translateY}%)`;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl"
.circles
  width: 100%
  height: 100%
  position: absolute
  z-index: 0
.circle
  border-radius: 50%
  background: rgba(0,0,0,0.2)
  height: 50px
  width: 50px
  position: absolute
</style>
